// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from SwiperCarouselArrows.module.scss  */
.SwiperCarouselArrows-module-Root_2B6 {
  display: none; }
  @media all and (min-width: 768px) {
    .SwiperCarouselArrows-module-Root_2B6 {
      position: absolute;
      z-index: 5;
      top: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px !important;
      height: 40px;
      padding: 0;
      border: 0;
      border-radius: 50%;
      will-change: transform; }
      .SwiperCarouselArrows-module-Root_2B6[disabled] {
        opacity: 0; } }

.SwiperCarouselArrows-module-RootPrev_2J4 {
  left: 0;
  transform: translate(-50%, -50%); }

.SwiperCarouselArrows-module-RootNext_31Z {
  right: 0;
  transform: translate(50%, -50%); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/SwiperCarousel/SwiperCarouselArrows/SwiperCarouselArrows.css"],"names":[],"mappings":"AAAA,qDAAqD;AACrD;EACE,aAAa,EAAE;EACf;IACE;MACE,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,sBAAsB;MACtB,YAAY;MACZ,UAAU;MACV,SAAS;MACT,kBAAkB;MAClB,sBAAsB,EAAE;MACxB;QACE,UAAU,EAAE,EAAE;;AAEtB;EACE,OAAO;EACP,gCAAgC,EAAE;;AAEpC;EACE,QAAQ;EACR,+BAA+B,EAAE","sourcesContent":["/*  imported from SwiperCarouselArrows.module.scss  */\n.SwiperCarouselArrows-module-Root_2B6 {\n  display: none; }\n  @media all and (min-width: 768px) {\n    .SwiperCarouselArrows-module-Root_2B6 {\n      position: absolute;\n      z-index: 5;\n      top: 50%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 40px !important;\n      height: 40px;\n      padding: 0;\n      border: 0;\n      border-radius: 50%;\n      will-change: transform; }\n      .SwiperCarouselArrows-module-Root_2B6[disabled] {\n        opacity: 0; } }\n\n.SwiperCarouselArrows-module-RootPrev_2J4 {\n  left: 0;\n  transform: translate(-50%, -50%); }\n\n.SwiperCarouselArrows-module-RootNext_31Z {\n  right: 0;\n  transform: translate(50%, -50%); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
